"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _StaticPage = require("web/shared/components/StaticPage.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The shell for a simple static content page: a centered, comfortably-wide
* column with a heading and the page's body. Keeps such pages consistent
* and free of layout details.
*/
function StaticPage(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("article", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_StaticPage.styles.wrapper, props.measure === "wide" && _StaticPage.styles.wrapperWide)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_StaticPage.styles.title)), {}, {
      children: props.title
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_StaticPage.styles.body)), {}, {
      children: props.children
    }))]
  }));
}
var _default = exports.default = StaticPage;